// extracted by mini-css-extract-plugin
export default {"figure":"los-angeles-module--figure--2W0lV","capabilities":"los-angeles-module--capabilities--1N-fc","weAre":"los-angeles-module--we-are--10DpH"};